/**
 * This class contains methods to do with the sell screen.
 * They are being built in this class so we can more easily test them, and we aren't growing the Angular SellCtrl.
 */
class SellService {
    /**
     * @param {UserService} userService
     */
    constructor(
        userService,
    ) {
        this.userService = userService;
    }

    /**
     * @param {AbstractItem} item
     *
     * @returns {Branch}
     */
    getBranchForItem(item) {
        // This item may have come from a barcode scan, which means it may not be in the currently selected
        // item branch. Check if this item is available in the current item branch. If it's not, use the first
        // branch that it's available in.
        if (item.branchIDs.includes(this.userService.currentItemBranch.ID)) {
            // The item is available in the already-selected item branch.
            return this.userService.currentItemBranch;
        }

        if (!this.userService.company.settings.enableCrossBranchSelling) {
            // The item is not available in the current branch, and cross-branch selling is not enabled.
            throw new Error(`${item.itemType} ${item.ID} is not available in the current branch.`);
        }

        // Use the first branch this item does belong to.
        let itemBranchID = item.branchIDs[0];
        if (!itemBranchID) {
            throw new Error(`${item.itemType} ${item.ID} is not available in any branches.`);
        }

        // Try to get the branch from the current user.
        const branch = this.userService.getBranchByID(itemBranchID);
        if (!branch) {
            throw new Error(`A branch for ${item.itemType} ${item.ID} could not be loaded.`);
        }

        return branch;
    }
}

module.exports = SellService;
